import {
  LegacyPage,
  Model,
  Panels,
  Bar,
  Breadcrumb,
  LoadingContainer,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useRouteMatch, useParams } from 'peach/router'

import { R } from 'core/helpers'
import {
  useInternalGetTemplateDescriptor,
  useInternalListTemplateVersionsByDescriptor,
} from 'core/types'

import TemplateEditor from './TemplateEditor/TemplateEditor'

const CompanyDescriptor = () => {
  const { url } = useRouteMatch()
  const { companyId, descriptorId } = useParams<{
    companyId?: string
    descriptorId?: string
  }>()

  const {
    data: descriptor,
    isLoading: descriptorLoading,
    error: descriptorError,
  } = useInternalGetTemplateDescriptor({
    companyId,
    descriptorId,
  })

  const { data: templates, isLoading: isLoadingTemplates } =
    useInternalListTemplateVersionsByDescriptor({
      companyId,
      descriptorId,
    })

  const template = R.find(
    templates ?? [],
    (template) => template.id === descriptor?.activeVersionId,
  )

  const onSaveTemplate = (newTemplateData, diff) => {
    console.info(newTemplateData, diff)
    // Add actual save implementation here using a mutation hook
  }

  const editTemplate = template && descriptor && (
    <TemplateEditor
      descriptor={descriptor}
      onSaveTemplate={onSaveTemplate}
      template={template}
      triggerButtonLabel='Edit Template'
    />
  )

  const header = <Bar right={editTemplate} />
  const isLoading = descriptorLoading || isLoadingTemplates

  return (
    <LoadingContainer error={descriptorError} isLoading={isLoading}>
      <Panels header={header}>
        <Breadcrumb title={getName(descriptor)} to={url} />
        <LegacyPage.Full>
          <Model.Item json={descriptor} />
          <Model.Item json={templates} title='Templates' />
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default CompanyDescriptor
